import type { ReactNode } from "react";
import { Tag } from "@pack-it-up/ui-web";
import * as styles from "./RowTags.css.js";

// Read-only tag chips on a list row (T29). A row's trailing slot already carries the
// quantity badge and assignment chips, so at most two tags are shown and the rest
// collapse into a muted "+N" that reveals them on hover or keyboard focus.
const MAX_VISIBLE = 2;

export const RowTags = ({ tags }: { tags?: string[] }): ReactNode => {
  if (tags === undefined || tags.length === 0) return null;
  const shown = tags.slice(0, MAX_VISIBLE);
  const hiddenTags = tags.slice(MAX_VISIBLE);
  return (
    <>
      {shown.map((t) => (
        <Tag key={t} label={t} />
      ))}
      {hiddenTags.length > 0 && (
        // tabIndex makes the tooltip reachable without a pointer; the accessible name
        // carries the same list, so a screen reader never needs the hover at all.
        <span
          className={styles.wrapper}
          tabIndex={0}
          aria-label={`${hiddenTags.length} more tags: ${hiddenTags.join(", ")}`}
        >
          <Tag label={`+${hiddenTags.length}`} />
          <span className={styles.tooltip} role="tooltip">
            {hiddenTags.map((t) => (
              <Tag key={t} label={t} />
            ))}
          </span>
        </span>
      )}
    </>
  );
};
